import Checklist from '../../src/legacy/Checklist.tsx';
export default Checklist;
